import PostMerchantBlueThumb from '@components/Post/MerchantBlueThumb';
import { Resource } from '@core';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import * as styles from './postSidebarMerchantCard.module.css';

interface Props extends StyleProps {
  merchant: Resource;
}

export const PostSidebarMerchantCard: FC<Props> = ({ className, style, merchant }) => {
  const { merchantName, webDescription, webLink } = merchant;
  return (
    <a className={mc('flex flex-col', className)} style={style} target="_blank" href={webLink}>
      <div className={mc('flex flex-row items-center')}>
        <PostMerchantBlueThumb className={mc('w-28 h-28 basis-28 shrink-0 grow-0')} merchant={merchant} />
        {!!merchantName && (
          <h5 className={mc('m-0 ml-4', 'text-xl font-raleway leading-normal font-bold text-ocean-blue')}>{merchantName}</h5>
        )}
      </div>
      <div className="mt-4">
        <p className={mc('font-raleway leading-normal font-medium text-ocean-blue', styles.description)}>{webDescription}</p>
      </div>
    </a>
  );
};

export type PostSidebarMerchantCardProps = Props;
export default PostSidebarMerchantCard;
